import React from "react";
import { Modal } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const LinkedAgreementsModal = ({ visible, onClose, linkedAgreements }) => {
  const navigate = useNavigate();

  return (
    <Modal
      title="Linked Agreements"
      open={visible}
      footer={null}
      onCancel={onClose}
    >
      {linkedAgreements?.map((item) => (
        <div
          key={item.linked_agreement_id}
          className="cursor-pointer mb-2 flex justify-between items-center my-5"
          onClick={() => {
            onClose();
            navigate(`/admin/contracts/${item.linked_agreement_id}`);
          }}
        >
          <div>{item.linked_document_id}</div>
          <ExportOutlined
            className="text-blue-600 cursor-pointer"
            onClick={() => {
              onClose();
              navigate(`/admin/contracts/${item.linked_agreement_id}`);
            }}
          />
        </div>
      ))}
    </Modal>
  );
};

export default LinkedAgreementsModal;
